import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useReducer,
} from "react";

import { TranslatedString } from "@bosch/bt-ui";

import "./MainAppBar.css";
import withErrorHandler from "./ErrorHandler";
import LogOut from "./LogOut.jsx";
import { AppHeader } from "./AppHeader.jsx";

function getUserInfoForProfileAccess(userInfo) {
  return {
    loggedInUsername: <TranslatedString stringId={userInfo.info} />,
    name: userInfo.name,
    monogram: null,
    email: userInfo.email,
  };
}

const MainAppBar = (props) => {
  const { token, isDirty, pageTitle, pageSubtitle } = props;

  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logOut = useCallback(() => {
    if (!isDirty) {
      setIsAccountMenuOpen(false);
      setIsLoggingOut(true);
    }
  }, [isDirty]);

  const environment = MOBY_ENV || "prod";

  const toMyProfile = useCallback(() => {
    window.location.href =
      environment === "prod"
        ? "https://id.keenfinity.tech/29cc5a37-9389-40e1-b16c-3686d3f4ebcc/oauth2/v2.0/authorize?p=B2C_1A_EDIT&client_id=93a14114-590a-4321-b11b-c47354960396&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fid.keenfinity.tech%2F&scope=openid&response_type=code"
        : "https://stage.id.keenfinity.tech/2cbf6610-6d86-4799-9b4d-7ffa342a5115/oauth2/v2.0/authorize?p=B2C_1A_EDIT&client_id=6ad65d59-c25a-4fa6-913e-0849f05b4ac6&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fstage.id.keenfinity.tech%2F&scope=openid&response_type=code";
  });

  const isLoggedIn = token && token.authenticated ? true : false;

  return (
    <React.Fragment>
      {isLoggingOut && <LogOut />}
      <AppHeader
        pageTitle={pageTitle}
        pageSubtitle={pageSubtitle}
        profileAccess={
          isLoggedIn
            ? {
                isLoggedIn: true,
                user: getUserInfoForProfileAccess(token.user),
                logoutLink: {
                  text: <TranslatedString stringId="Logout" />,
                  onClick: logOut,
                },
                profileLink: {
                  text: (
                    <TranslatedString stringId="My Profile" />
                  ),
                  onClick: toMyProfile,
                },
                token,
              }
            : {
                isLoggedIn: false,
                loginLink: {
                  text: <TranslatedString stringId="Login" />,
                  href: "/login",
                },
              }
        }
      />
    </React.Fragment>
  );
};

export default withErrorHandler(React.memo(MainAppBar));
